import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import { Link } from 'react-router-dom';
import { Box, BlockLink } from '@qga/roo-ui/components';
import { Image } from '@qga/components';

const StyledBox = styled(Box)`
  position: relative;
`;

const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 0;
  padding-bottom: 40%;
  border-radius: 4px 4px 0 0;

  ${themeGet('mediaQueries.0')} {
    border-radius: 4px 0 0 4px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const StyledImg = styled(Image)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

StyledImg.displayName = 'PropertyImage';

interface CardImageProps {
  src: string;
  alt: string;
  link: {
    url: string;
  };
  [key: string]: any;
}

export const CardImage = ({ src, alt, link, ...props }: CardImageProps) => (
  <StyledBox width={['100%', '44%']} {...props}>
    <BlockLink as={Link} to={link.url}>
      <ImageWrapper>
        <StyledImg src={src} alt={alt} />
      </ImageWrapper>
    </BlockLink>
  </StyledBox>
);
